import { useParams, useSearchParams } from "react-router";

import { getSearchQuery } from "components/SearchInput/helpers";
import useSearchSpaceliftVcsFiles from "shared/SpaceliftVcsRepo/useSearchSpaceliftVcsFiles";

const useSpaceliftVcsSearchFiles = () => {
  const { repoId } = useParams<{ repoId: string }>();
  const [searchParams] = useSearchParams();
  const searchQuery = getSearchQuery(searchParams);

  return useSearchSpaceliftVcsFiles({
    repoId,
    fullTextSearch: searchQuery,
    skip: !searchQuery,
  });
};

export default useSpaceliftVcsSearchFiles;
